import { useEffect } from 'react';
import { API_URL } from '../config/apiConfig';
import {
  clearAlternateArtDisplayContext,
  loadAlternateArtDisplayContextFromProgress,
} from '../utils/alternateArtDisplay';

/**
 * Loads account alternate-art prefs once per login for all OrderDesign / getOrderCardImageSrc callers.
 * @param {{ userId?: number } | null | undefined} user
 */
export function useAlternateArtDisplayBootstrap(user) {
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!user?.userId || !token) {
      clearAlternateArtDisplayContext();
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        await loadAlternateArtDisplayContextFromProgress(API_URL, token);
      } catch (err) {
        if (!cancelled) {
          console.error('useAlternateArtDisplayBootstrap failed:', err);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [user?.userId]);
}
